import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user-service/user.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { map, tap } from 'rxjs/internal/operators';
import { BoService } from 'src/app/services/bo-service/bo.service';
import { CommunicationService } from 'src/app/services/communication-service/communication.service';
import { NotificationsService } from 'src/app/services/notifications-services/notifications.service';

@Component({
  selector: 'app-account-selector-card',
  templateUrl: './account-selector-card.component.html',
  styleUrls: ['./account-selector-card.component.scss']
})
export class AccountSelectorCardComponent implements OnInit {

  companyList;
  public errorMessage: string;
  private signInSubscription: Subscription;

  constructor(private userService: UserService,
    private userStorageService: UserStorageService,
    private router: Router,
    private boService: BoService,
    private communicationService: CommunicationService,
    private notificationsService: NotificationsService
  ) {
    this.companyList = userStorageService.getCompanList();
  }

  ngOnInit() {
  }

  selectCompany( companyCode: string ) {
    this.signInSubscription = this.userService.selectCompany(
      this.userStorageService.getTmpContext(),
      this.userStorageService.getLang(),
      this.userStorageService.getUDID(),
      companyCode).subscribe(
      (res) => {
        if (res) {
          this.setUserStorageData(res['data']);
          this.getVersion();
          this.router.navigate(['']);
          this.socketsConnect();
        }
      },
      (error) => {
        this.errorMessage = error;
      }
    );
  }

  private setUserStorageData(data) {
    this.userStorageService.setCompanyData(data['companyData']);
    this.userStorageService.setContext(data['context']);
    this.userStorageService.setMenuSectionList(data['menuOptions']);
    this.userStorageService.setUserData(data['userData']);
    this.userStorageService.setCenterList(data['centerList']);
  }

  private getVersion() {
    this.boService.getVersion().pipe(
      tap(o => {
        if (this.userStorageService.setBOVersion(o)) {
          if (this.boService.newVersionAvailable()) {
            this.notificationsService.notificate('fas fa-sync-alt', 'New version available', false, 'window.location.reload(true);');
          }
        }
      })
    );
  }

  private socketsConnect() {
    this.communicationService.getSocketChannels().pipe(
      map(socketChannels => this.userStorageService.setSocketChannels(socketChannels['channelList'])),
      map(socketChannels => this.userStorageService.getSocketChannels().filter(sc => sc.FlagCompany === true)[0]),
      map(socketChannel => this.communicationService.listenCommunications(socketChannel))
    ).subscribe();
  }

}
